import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "info-panel-card-container" }
const _hoisted_2 = { class: "info-panel-header" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = {
  key: 0,
  class: "required-level"
}
const _hoisted_5 = {
  key: 1,
  class: "drugs-duration"
}
const _hoisted_6 = {
  key: 0,
  class: "other-requirements"
}
const _hoisted_7 = {
  key: 1,
  class: "other-requirements"
}
const _hoisted_8 = { class: "info-panel-description" }
const _hoisted_9 = {
  key: 0,
  class: "ul notes"
}
const _hoisted_10 = {
  key: 1,
  style: {"margin-top":"4px"}
}
const _hoisted_11 = { class: "ul modifies" }
const _hoisted_12 = {
  key: 2,
  style: {"margin-top":"4px"}
}
const _hoisted_13 = { class: "ul bonuses" }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "ul penalties" }
const _hoisted_16 = {
  key: 4,
  style: {"margin-top":"4px"}
}
const _hoisted_17 = {
  key: 5,
  class: "ul notes"
}
const _hoisted_18 = { class: "info-panel-image" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 2,
  class: "wiki-button"
}
const _hoisted_21 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.infoPanelData.name), 1),
      (_ctx.show.requiredLevel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, _toDisplayString('Level: ' + _ctx.state.build[_ctx.infoPanelData.type][_ctx.infoPanelData.key].level), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.show.drugsDuration)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Duration: 30 RT minutes "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.show.requirements)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[0] || (_cache[0] = _createElementVNode("div", null, "Requirements:", -1)),
          _createElementVNode("div", null, _toDisplayString(_ctx.infoPanelData.requirements), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.show.modifiedBy)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[1] || (_cache[1] = _createElementVNode("div", null, "Modified by:", -1)),
          _createElementVNode("div", null, _toDisplayString(_ctx.infoPanelData.modifiedBy.join(', ')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "content-wrapper",
      style: _normalizeStyle(_ctx.show.requirements || _ctx.show.modifiedBy ? 'height: 132px;' : 'height: 146px;')
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createTextVNode(_toDisplayString(_ctx.infoPanelData.description) + " ", 1),
        (_ctx.show.notes)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoPanelData.notes, (note) => {
                return (_openBlock(), _createElementBlock("li", { key: note }, _toDisplayString(note), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.show.modifies)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("span", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.infoPanelData.type === 'Skills' ? 'Related Perks,Boosts & Professions' : (_ctx.infoPanelData.name + ' modifies:')), 1)
              ]),
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoPanelData.modifies, (item) => {
                  return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.show.bonuses)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[2] || (_cache[2] = _createElementVNode("span", null, [
                _createElementVNode("b", null, "Bonuses")
              ], -1)),
              _createElementVNode("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoPanelData.bonuses, (bonus) => {
                  return (_openBlock(), _createElementBlock("li", { key: bonus }, _toDisplayString(bonus), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.show.penalties)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[3] || (_cache[3] = _createElementVNode("span", null, [
                _createElementVNode("b", null, "Penalties")
              ], -1)),
              _createElementVNode("ul", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoPanelData.penalties, (penalty) => {
                  return (_openBlock(), _createElementBlock("li", { key: penalty }, _toDisplayString(penalty), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.show.implantRequirements)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("span", null, [
                _createElementVNode("b", null, "Surgery requirements:")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.show.implantNotes)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoPanelData.notes, (note) => {
                return (_openBlock(), _createElementBlock("li", { key: note }, _toDisplayString(note), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ], 4),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("img", {
        src: _ctx.getImage(_ctx.infoPanelData.type, _ctx.infoPanelData.image),
        width: "80",
        height: "80"
      }, null, 8, _hoisted_19)
    ]),
    (_ctx.show.wikiButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_GenericButton, {
            title: "Read more on FOnline Reloaded Wiki page",
            transparent: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                class: "a",
                href: _ctx.infoPanelData.wiki,
                target: "_blank"
              }, "Check Wiki", 8, _hoisted_21)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}